import { View } from "@/components/ui";
// import { ArrowLeft } from "@/components/shared/icons";
// import { Link } from "@/components/shared/link";
import { AccountInfoList } from "@/components/shared/account-info-list";
import { ChangePhoneNumberModalContainer } from "../change-phone-number";
import { Typography } from "@/components/shared/typography";
import { IconButton } from "@/components/ui/icon-button/index.web";
import { useRoute } from "@/components/shared/router";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";

export const AccountInfo = () => {
  const { push } = useRoute();
  const { isMobile } = useWindowDimensions();
  return (
    <View className="z-10 h-full flex-1 px-4 md:px-0">
      <View className="mb-4 border-b md:mb-8 md:pb-4">
        <View className="flex flex-row items-center gap-2 py-4 md:p-0">
          {/* CONSISTENECY PROBLEM <Link href="/profile" className="md:hidden">
            <ArrowLeft className="visible size-5" />
          </Link> */}
          <IconButton
            variant={isMobile ? "ghost" : "secondary"}
            color="foreground"
            iconName="arrowLeft"
            rounded="full"
            className="p-0 md:hidden md:px-3 md:py-2"
            onClick={() => push({ pageKey: "profile" })}
          />
          <Typography variant="label-md">Account Info</Typography>
        </View>
      </View>
      <AccountInfoList />
      <ChangePhoneNumberModalContainer />
    </View>
  );
};
